import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';

import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';
import createIcon from '../../../../static/img/createIcon.svg';
import { InputFilterCell } from '~/src/components/common/grid/InputFilterCell';
import TableButton from '~/src/components/common/forms/Button/TableButton';

export default function WarehousesList() {
  const stateRef = useRef(null);
  const history = useHistory();
  const url = `${API_URL}/warehouses/get`;
  const StatefullGrid = withState(Grid, url);

  const ProductNameCell = (row, ref) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/warehouses/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  const InventoryButtonCell = (row) => {
    const { dataItem } = row;
    return (
      <td>
        <Link
          to={`/inventory/for-warehouse/${dataItem.id}?warehouseName=${encodeURIComponent(dataItem.name)}`}
        >
          <TableButton title="View Inventory" />
        </Link>
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="Warehouses"
        titleRight="Create order"
        onRightHandler={(): void => history.push('/warehouses/create')}
        iconRight={createIcon}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Name" cell={(row) => ProductNameCell(row, stateRef)} />
          <GridColumn
            field="inventory"
            title="Inventory"
            filterable={false}
            sortable={false}
            cell={(row) => InventoryButtonCell(row)}
          />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}